import angular from 'angular';
import Library from './library/library';
import Login from './login/login';
import ClientDashboard from './clientDashboard/clientDashboard';
import ClientAuthorizations from './clientAuthorizations/clientAuthorizations';

let pagesModule = angular.module('app.pages', [
  Library,
  Login,
  ClientDashboard,
  ClientAuthorizations,

])

.name;

export default pagesModule;



// WEBPACK FOOTER //
// ./src/app/pages/pages.js